<template>
  <ResidentialProperties
    v-model="comp"
    :sortable="sortable"
    :filter="filterItems"
    :model="model"
    :parent="parent"
    v-bind="$attrs"
    v-on="$listeners"
    :type="type"
    class="residential-field-properties"
  >
    <template v-if="showSettingsAlert" #after>
      <Alert class="mt-4" theme="primary">
        <div
          v-html="
            $t('editFieldsInUnitListAlert', {
              link: `<button id='alert-button'> ${$t('here').toLowerCase()}</button>`,
            })
          "
        ></div>
      </Alert>
    </template>
  </ResidentialProperties>
</template>

<script>
import { ValueComp } from '@/utils'
import ResidentialProperties from '@/components/Residential/Properties'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { i18n } from '@/i18n'

const meta = {
  order: 3,
  label: i18n.t('residentialProperties'),
}

export { meta }
export default {
  props: {
    value: Array,
    model: {
      type: String,
      default: 'Residential',
    },
    parent: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'property',
    },
    setDefaultValues: Boolean,
  },
  data() {
    return {
      alertButton: {},
    }
  },

  computed: {
    comp: ValueComp(),
    label: () => meta.label,
    sortable() {
      const usedProperties = this.$path('project.metadata.siteSettings.residentialProperties', this.parent) || {}

      return !Boolean(Object.values(usedProperties).find(i => i.type === this.type && i.order))
    },
    showSettingsAlert() {
      return this.type === 'property' && this.model === 'Residential'
    },
  },
  methods: {
    navigate() {
      return this.$router.push({
        name: 'project-edit',
        params: { id: this.parent.project.id, step: 'residentials' },
        query: { residentialsSettingsOpen: 'list' },
      })
    },
    setDefaultProperties() {
      if (this.$store.state.enums.ResidentialProperties)
        return this.$store.state.enums.ResidentialProperties.filter(
          ({ required, models = [] }) => required && (!models.length || models.includes(this.model)),
        ).map(({ key }) => ({ key, label: null, value: null }))
    },
    filterItems(p) {
      switch (this.type) {
        case 'facility':
          return p.type === 'facility'
        case 'property':
          return !(p.type === 'facility')
      }
      return false
    },
  },
  mounted() {
    //set default if no properties has value
    if (this.setDefaultValues && !this.comp.some(i => Boolean(i.value))) {
      this.comp = this.setDefaultProperties()
    }

    this.alertButton = document.querySelector('#alert-button')

    if (this.showSettingsAlert) {
      this.$nextTick(() => {
        this.alertButton.addEventListener('click', this.navigate)
      })
    }
  },
  beforeDestroy() {
    if (this.showSettingsAlert) {
      const button = document.querySelector('#alert-button')
      this.alertButton.removeEventListener('click', this.navigate)
    }
  },
  components: {
    ResidentialProperties,
    Alert,
  },
}
</script>

<style lang="scss">
.residential-field-properties {
  #alert-button {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
